import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=07d1c6f0&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=07d1c6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1c6f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d1c6f0')) {
      api.createRecord('07d1c6f0', component.options)
    } else {
      api.reload('07d1c6f0', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=07d1c6f0&scoped=true&", function () {
      api.rerender('07d1c6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MessageList.vue"
export default component.exports